import { SUPABASE_ANON_KEY, SUPABASE_URL, isBuilderEditingMode } from './utils'
import { log } from './debug'
import { cloneDeep } from 'lodash'

let attemptNumber = 0

const baseInterval = 3 * 1000
const maxInterval = 60 * 60 * 1000
const intervalFactor = 2

const rrwebScript =
  'https://cdn.jsdelivr.net/npm/rrweb@2.0.0-alpha.4/dist/record/rrweb-record.min.js'
export default function start(projectId: string, contactId: string, pageloadId: string) {
  const scriptSelector = `[src="${rrwebScript}"]`
  if (document.querySelector(scriptSelector)) {
    log('Session Replay: Skipping - already installed')
    sessionReplayDebug('Session Replay: Skipping - already installed')
    return
  }

  log('Session Replay: Starting')
  sessionReplayDebug('Session Replay: Starting')
  let events: any[] = []

  // save events every 10 seconds
  installRrweb()
  let currentTimeout = setTimeout(() => save(attemptNumber, baseInterval), baseInterval)

  function installRrweb() {
    log('Session Replay: Installing Script')
    sessionReplayDebug('Session Replay: Installing Script')
    var script = document.createElement('script')
    script.src = rrwebScript
    document.head.appendChild(script)
    script.onload = function () {
      log('Session Replay: Script Loaded')
      sessionReplayDebug('Session Replay: Script Loaded')
      const searchParams = new URL(window.location.toString()).searchParams
      if (
        (window.location.hostname === 'localhost' || isBuilderEditingMode()) &&
        searchParams.get('savvy_track') !== 'true'
      )
        return
      let i = 0
      setInterval(() => {
        i++
        sessionReplayDebug(`Session Replay: ${i} second elapsed`)
      }, 1000)

      window.rrwebRecord({
        emit(event: any) {
          // push event into the events array
          events.push(event)
        },
        recordCanvas: true,
        sampling: {
          canvas: 5,
        },
        // optional image format settings
        dataURLOptions: {
          type: 'image/webp',
          quality: 0.6,
        },
      })
    }
  }

  // this function will send events to the backend and reset the events array
  function save(localAttemptNumber: number, interval: number) {
    const body = JSON.stringify({ events, interval })
    events = []
    // console.log('saving events', body);

    const timestamp = new Date().toISOString()

    const path = `${projectId}/${contactId}/${pageloadId}/${timestamp}.json`

    log('Session Replay: Saving to cloudflare', {
      path,
      body: body?.slice(0, 100),
    })
    sessionReplayDebug('Session Replay: Saving to cloudflare')
    // TODO: DEV-266 — Commented out because saveToClickhouse hits https://sessions.embeddables.com via the
    // old proxy path and is causing console errors on customer sites (no functionality impact).
    // We need to decide whether to fix the endpoint or remove this entirely before re-enabling.
    // try {
    //   saveToClickhouse(path, body)
    // } catch (error) {
    //   console.warn('Error saving to Clickhouse', path, body, error)
    // }
    try {
      saveToCloudflareStorage(path, body)
    } catch (error) {
      console.warn('Error saving to Cloudflare', path, error)
    }

    const newInterval = calculateBackoffInterval(
      localAttemptNumber,
      baseInterval,
      maxInterval,
      intervalFactor
    )
    log(`Session Replay: Next interval is ${parseInt(`${newInterval}`)}`)
    sessionReplayDebug(`Session Replay: Next interval is ${parseInt(`${newInterval}`)}`)
    currentTimeout = setTimeout(() => save(localAttemptNumber + 1, newInterval), newInterval)
  }
}

function saveToSupabaseStorage(path: string, body: string) {
  const bucketName = 'session_replays_1'

  fetch(`${SUPABASE_URL}/storage/v1/object/${bucketName}/${path}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
      apikey: SUPABASE_ANON_KEY,
    },
    body,
  })
}

function saveToCloudflareStorage(path: string, body: string) {
  const cloudflareUrlBase = 'https://session-replays.heysavvy.workers.dev'
  const url = `${cloudflareUrlBase}/${path}`
  const proxyUrl = `https://proxy.trysavvy.com/?url=${url}`

  fetch(proxyUrl, {
    method: 'POST',
    body,
  })
}

// TODO: DEV-266 — saveToClickhouse is commented out because it hits https://sessions.embeddables.com
// via the old proxy path, causing console errors on customer sites without affecting functionality.
// We need to decide whether to fix the endpoint or remove this function entirely before re-enabling.
// async function saveToClickhouse(path: string, body: string) {
//   log('Session Replay: Saving to clickhouse', {
//     path,
//     body: body?.slice(0, 100),
//   })
//   sessionReplayDebug('Session Replay: Saving to clickhouse')
//   const [projectId, contactId, pageloadId, timestamp] = path.replace('.json', '').split('/')
//   const record = {
//     project_id: projectId,
//     contact_id: contactId,
//     pageload_id: pageloadId,
//     timestamp: timestamp,
//     // json_payload: body,
//   }
//
//   const options = {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     body: JSON.stringify({
//       table: 'session_replays',
//       data: record,
//     }),
//   }
//
//   const response = await fetch(`https://sessions.embeddables.com`, options)
//   log('Session Replay: Response from clickhouse', response)
//   sessionReplayDebug(`Session Replay: Response from clickhouse: ${response.status}`)
// }

function calculateBackoffInterval(
  attemptNumber: number,
  baseInterval: number,
  maxInterval: number,
  factor: number
) {
  const interval = Math.min(maxInterval, baseInterval * Math.pow(2, attemptNumber / factor))
  return interval
}

function sessionReplayDebug(text: string) {
  setTimeout(() => {
    try {
      sessionReplayDebug1(text)
    } catch (error) {
      console.warn('Error in sessionReplayDebug', error)
      setTimeout(() => {
        try {
          sessionReplayDebug1(text), 1000
        } catch (error) {
          console.warn('Error in sessionReplayDebug', error)
        }
      })
    }
  }, 50)
}

function sessionReplayDebug1(text: string) {
  if (
    window.location.hostname === 'localhost' ||
    (window.location.host === 'safeandtogetherinstitute.com' &&
      window.location.pathname === '/home/your-recommendations/')
  ) {
    const debug = cloneDeep(
      (window.Savvy as any).getUserData('X0UUXXcFgORFVfcLr0TG').session_replay_debug || []
    )

    if (debug.length < 30) {
      debug.push(text)
      console.log('text, debug', text, debug)
      ;(window.Savvy as any).setUserData('X0UUXXcFgORFVfcLr0TG', { session_replay_debug: debug })
    }
  }

  if (
    window.location.hostname === 'localhost' ||
    (window.location.host === 'safeandtogetherinstitute.com' && window.location.pathname === '/')
  ) {
    const debug = cloneDeep(
      (window.Savvy as any).getUserData('HtIiHOzRiGb5vToQZXcn').session_replay_debug || []
    )

    if (debug.length < 30) {
      debug.push(text)
      console.log('text, debug', text, debug)
      ;(window.Savvy as any).setUserData('HtIiHOzRiGb5vToQZXcn', { session_replay_debug: debug })
    }
  }
}
